module.exports = __webpack_public_path__ + "static/media/no-image.6f6bbb16.png";